import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';

import { isMobileOrTablet } from 'helpers/Device';

/**
 * Icon tooltip
 * @param {string} tooltipText - Tooltip text describing the field
 */
class Tooltip extends Component {
    /**
     * React lifecycle
     */
    constructor(props) {
        super(props);

        /**
         * Tooltip default state
         * @type {Object}
         */
        this.state = {
            tooltipIsOpen: false,
        };

        this.toggleTooltipCaret = this.toggleTooltipCaret.bind(this);
    }

    /**
     * Change state of tooltip caret display.
     * @param {Boolean} tooltipState New tooltip state
     */
    toggleTooltipCaret(tooltipState) {
        this.setState({ tooltipIsOpen: tooltipState });
    }

    /**
     * React lifecycle
     */
    render() {
        const { tooltipId, tooltipText } = this.props;

        const tooltipIsOpenClass = classnames({
            'tooltip__icon--is-open': this.state.tooltipIsOpen,
        });

        return (
            <div className="tooltip tooltip--estima-form">
                <span
                    data-for={tooltipId}
                    className={`icon-info_outline tooltip__icon--estima-form ${tooltipIsOpenClass}`}
                    data-tip={tooltipText}
                    data-event={`${isMobileOrTablet() ? 'click' : ''}`}
                />
                <ReactTooltip
                    id={tooltipId}
                    className="tooltip__panel tooltip__panel--estima-form"
                    place="bottom"
                    effect="solid"
                    globalEventOff="touchstart"
                    afterShow={() => this.toggleTooltipCaret(true)}
                    afterHide={() => this.toggleTooltipCaret(false)}
                />
            </div>
        );
    }
}

Tooltip.displayName = 'DefaultTooltip';

Tooltip.propTypes = {
    tooltipId: PropTypes.string.isRequired,
    tooltipText: PropTypes.string.isRequired,
};

/**
 * Tooltip Functionnal Component
 */
export default Tooltip;
